import {idPrefixToEntityName} from '../idHelpers.config';
import {InvalidIdError} from '../idHelpers.types';

export default function formatInvalidIdError(error: InvalidIdError): string {
  const entityName = error.expectedPrefix.map((p) => idPrefixToEntityName[p]).join(' or ');

  return `Invalid ${entityName} ID: ${error.rawValue}`;
}
